﻿$.fn.dxCtrlPreviSondage = function custom_dxCtrlPreviSondage(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlprevisondage dx-ctrl");
        this.createInstance(new cdxCtrlPreviSondage(this, option));
    }
    return this;
}

window.cdxCtrlPreviSondage = function (container, option) {
    var Me = this;
    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    if (typeof option.inPopup == 'undefined') option.inPopup = true

    function mConstruit() {
        container.empty()
        if (option.inPopup) {
            var popup = $("<div/>").appendTo("body").dxCtrlPopupBase({
                fullScreen: true,
                showTitle: false,
                contentTemplate: function (contentElement) {
                    contentElement.css("position", "relative")
                    mRempli(contentElement)

                    dxBtClose = $("<div style='position:absolute;z-index:101;top:2px;right:2px'/>").appendTo(contentElement).dxCtrlButton({
                        icon: 'fas fa-times',
                        width: HeightButton,
                        height: HeightButton,
                        onClick: function (e) {
                            popup.hide()
                        }
                    }).dxCtrlButton("instance");
                }
            }).dxCtrlPopupBase("instance")
            popup.show()
        } else {
            container.css("position", "relative")
            mRempli(container)
        }
    }

    var $DivDetail = null
    var dxVisu = null
    function mRempli(contentElement) {
        var ds = ["Ordinateur de bureau", "Mobile"]
        var dxTabs = $("<div/>").appendTo(contentElement).dxTabs({
            dataSource: ds,
            selectedItem: ds[0],
            onSelectionChanged: function (e) {
                switch (ds.indexOf(e.addedItems[0])) {
                    case 0:
                        mRempliDeskTop()
                        break;
                    case 1:
                        mRempliMobile()
                        break;
                }
            }
        }).dxTabs("instance")

        $DivDetail = $("<div style='height:calc(100% - " + dxTabs.element().innerHeight() + "px);padding:5px;position:relative;'/>").appendTo(contentElement)
        resizeObserver.mAdd(dxTabs.element(), function () { $DivDetail.css("height", "calc(100% - " + dxTabs.element().innerHeight() + "px)") })

        //dxScroll = $("<div/>").appendTo($DivDetail).dxScrollView({}).dxScrollView("instance")
        //dxScroll.content().css("display", "relative")

        mRempliDeskTop()
    }

    function mHideOld() {
        var oldDxVisu = dxVisu
        if (oldDxVisu != null) {
            oldDxVisu.element().fadeOut(300, function () { oldDxVisu.element().remove() })
        }
    }

    function mRempliDeskTop() {
        mHideOld()
        dxVisu = $("<div style='width:100%;height:100%;display:none;'/>").appendTo($DivDetail).dxCtrlContentSondageSaisie({
            bddCtrl: option.bddCtrl,
            dataSondage: option.dataSondage,
            isInPopup: false,
            ignoreSave: true,
            indexSelectedPage: option.indexSelectedPage,
            isInPage:false
        }).dxCtrlContentSondageSaisie("instance")
        //dxVisu = $("<iframe style='height:100%;width:100%;border:none;display:none;'/>").appendTo($DivDetail)
        //dxVisu.on("load", function () {
        //    jauge.mHide()
        //})
        //dxVisu.element = function () { return dxVisu }
        //dxVisu.attr("src",option.url)
        dxVisu.element().fadeIn(300)
    }
    function mRempliMobile() {
        mHideOld()
        dxVisu = $("<div style='position:absolute;display:none;width:100%;height:100%;'/>").appendTo($DivDetail).dxCtrlEmailPrevisualisationMobile({
            contentTemplate: function (contentElement) {
                contentElement.css("overflow","hidden")
                return $("<div style='width:100%;height:100%;'/>").appendTo(contentElement).dxCtrlContentSondageSaisie({
                    bddCtrl: option.bddCtrl,
                    dataSondage: option.dataSondage,
                    isInPopup: false,
                    ignoreSave: true,
                    forcePhone: true,
                    indexSelectedPage: option.indexSelectedPage,
                    isInPage:false
                }).dxCtrlContentSondageSaisie("instance")
            },
            disabled: false
        }).dxCtrlEmailPrevisualisationMobile("instance")
        dxVisu.element().fadeIn(300)
    }

    this.element = function () { return container }

    mConstruit();
}